<template>
  <div class="col-md-6 ml-auto mr-auto pb-4">
    <form @submit.prevent="proceed()" class="vld-parent" ref="formContainer">
      <card class="card-login card-plain">
        <div slot="header">
          <div class="logo-container">
            <img  v-if="!appSettings.whiteLabelled" class="logo-img" src="@/assets/img/carenation.png" alt style="width: 100%" />
            <!-- <span style="color:white; float: right; font-size: 1.5em;">Clinic</span> -->
          </div>
        </div>

        <div class="text-center mb-2">
          <i class="fa fa-globe-asia" style="font-size: 1.2em; color: white"></i>
          <drop-down tag="div" :title="getLocaleName()">
            <a class="dropdown-item" @click="selectLanguage('en-US')" v-if="isSupportedLanguage('en-US')">English</a>
            <a class="dropdown-item" @click="selectLanguage('hi')" v-if="isSupportedLanguage('hi')">हिन्दी</a>
            <a class="dropdown-item" @click="selectLanguage('el-GR')" v-if="isSupportedLanguage('el-GR')">Ελληνικά</a>
            <a class="dropdown-item" @click="selectLanguage('es-ES')" v-if="isSupportedLanguage('es-ES')">Español</a>
            <a class="dropdown-item" @click="selectLanguage('ru')" v-if="isSupportedLanguage('ru')">русский</a>
            <a class="dropdown-item" @click="selectLanguage('kn')" v-if="isSupportedLanguage('kn')">ಕನ್ನಡ</a>
            <a class="dropdown-item" @click="selectLanguage('ar')" v-if="isSupportedLanguage('ar')">عربي</a>
            <a class="dropdown-item" @click="selectLanguage('fr')" v-if="isSupportedLanguage('fr')">française</a>
          </drop-down>
        </div>

        <div>
          <fg-input class="no-border form-control-lg" :placeholder="$t('message.Server')" autocapitalize="none" id="username" addon-left-icon="now-ui-icons business_globe" v-model="serverUrl"></fg-input>
        </div>
        <div style="text-align: center">
          <span style="color: var(--color-primary)" v-show="this.error != null || this.error != undefined">{{ error }}</span>
        </div>

        <div slot="footer">
          <n-button type="primary" nativeType="submit" round block>{{
            $t("message.OK")
          }}</n-button>
        </div>
      </card>
    </form>
  </div>
</template>
<script>
import { locale } from "moment";
export default {
  data() {
    return {
      serverUrl: "",
      error: "",
    };
  },

  methods: {
    async proceed() {
      if (this.serverUrl) {
        let baseUrl;
        if (!this.serverUrl.includes("http")) {
          baseUrl = "https://" + this.serverUrl.trim();
        } else {
          baseUrl = this.serverUrl.trim();
        }
        this.error = "";

        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: true,
          onCancel: this.onCancel,
        });
        try {
          // slash added to handle url with subdomain, ex: https://globalhospital.carenation.in/careportal will give invalid url with status 301
          let validation = await this.$store.dispatch(
            "validateUrl",
            baseUrl + "/"
          );

          if (validation.status == 200) {
            localStorage.baseUrl = baseUrl;
            this.$store.commit("setState", {
              stateName: "baseUrl",
              stateValue: localStorage.baseUrl,
            });

            this.$router.push("signin");
          } else {
            this.error = "Invalid url";
          }

          loader.hide();
        } catch (error) {
          loader.hide();
          this.error = "Invalid url";
        }
      }
    },
    clearError() {
      this.error = "";
    },
    isSupportedLanguage(code) {
      if (
        this.settings &&
        this.settings.supportedLanguages &&
        this.settings.supportedLanguages.length > 0
      ) {
        let language = this.settings.supportedLanguages.find((lang) => {
          return lang.code == code;
        });

        if (language) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    selectLanguage(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
    },
  },

  beforeDestroy() {
    this.$root.onBackButton = null;
  },

  computed: {
    defaultLocale() {
      return this.$store.state.locale;
    },
  },

  async mounted() {
    if (localStorage.baseUrl) {
      this.serverUrl = localStorage.baseUrl;
    } else {
      this.serverUrl = this.baseUrl;
    }

    // setting default locale
    if (this.defaultLocale) {
      this.selectLanguage(this.defaultLocale);
    }

    this.$root.onBackButton = () => {
      swal
        .fire({
          title: this.$t("message.Are you sure?"),
          confirmButtonText: this.$t("message.Exit"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.Stay"),
        })
        .then(async (result) => {
          if (result && result.value) {
            navigator.app.exitApp();
          }
        });
    };
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.logo-img {
  max-width: 500px;
}
</style>
<style scoped>
.dropdown.dropdown {
  display: inline-block;
}
.nav-link {
  color: #fff !important;
}
a.dropdown-toggle.nav-link {
  padding-left: 0.5em !important;
}
</style>

<style scope>
.modal.modal-mini .modal-footer button:first-child {
  opacity: 1;
}
</style>
<style scoped>
/deep/ .dropdown .dropdown-toggle {
  color: #fff;
}
</style>
